import { Territory, TerritoryRelation } from '__generated-api__';

export const getFullTerritoryName = (territory: Territory | TerritoryRelation) => {
  return territory.region ? `${territory.region.region_name} > ${territory.territory_name}` : territory.territory_name;
};
